export default __webpack_public_path__ + "static/media/leao-white.00f05223.svg";